// Import services & utilities
import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ISurveyFormsServiceResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";

/**
 * Async thunk to fetch survey forms.
 */
export const fetchSurveyForms = createServiceAsyncThunk<
  ISurveyFormsServiceResponse,
  number | undefined
>(
  ACTION_NAMES.FETCH_SURVEY_FORMS,
  (userId) => surveyFormsService.fetchSurveyForms(userId),
  ERROR_MESSAGES.FETCH_SURVEY_FORMS_FAILURE
);

/**
 * Slice for survey forms
 */
const surveyFormsSlice = createGenericSlice<
  ISurveyFormsServiceResponse,
  number | undefined
>(SLICE_NAMES.SURVEY_FORMS, fetchSurveyForms);

export const {
  clearError: clearSurveyFormsError,
  clearSuccessMessage: clearSurveyFormsSuccess,
} = surveyFormsSlice.actions;

export default surveyFormsSlice.reducer;
